module.exports = {
  errorAlert: function (msg, callback) {
    if ($("#error_alert")) {
      $("#error_alert").remove();
    }
    $("body").append(
      '<div class="error_alert" id="error_alert"><div class="mask"></div><div class="content"><span>' +
        msg +
        '</span><i class="iconfont">&#xe93c;</i></div></div>'
    );
    $("#error_alert").click(function () {
      $("#error_alert").remove();
    });
    window.document.onkeydown = function (event) {
      if (event && event.keyCode == 27) {
        $("#error_alert").remove();
      }
    };
  },
  alert: function (msg, callback) {
    if ($("#confirm_alert")) {
      $("#confirm_alert").remove();
    }
    $("body").append(
      '<div class="confirm_alert" id="confirm_alert"><div class="mask"></div><div class="content"><span>' +
        msg +
        '</span><div><span class="ok" id="confirm_ok">' +
        commonLocal.app.ok +
        "</span></div></div></div>"
    );
    $("#confirm_ok").click(function () {
      $("#confirm_alert").remove();
      callback();
    });
  },
  confirmAlert: function (msg, callback) {
    if ($("#confirm_alert")) {
      $("#confirm_alert").remove();
    }
    $("body").append(
      '<div class="confirm_alert" id="confirm_alert"><div class="mask"></div><div class="content"><span>' +
        msg +
        '</span><div><span class="clear" id="confirm_clear">' +
        commonLocal.Authorization.cancel +
        '</span><span class="ok" id="confirm_ok">' +
        commonLocal.app.ok +
        "</span></div></div></div>"
    );
    $("#confirm_clear").click(function () {
      $("#confirm_alert").remove();
    });
    $("#confirm_ok").click(function () {
      $("#confirm_alert").remove();
      callback();
    });
  },
  messageG: function (key, msg) {
    if (key == "success") {
      icon = "&#xe62b;";
    } else {
      icon = "&#xe62a;";
    }
    if ($("#messageG")) {
      $("#messageG").remove();
    }
    $("body").append(
      '<div class="message_box" id="messageG"><div class="messageG" ><i class="iconfont ' +
        key +
        '">' +
        icon +
        "</i><span>" +
        msg +
        "</span></div></div>"
    );
    setTimeout(function () {
      $("#messageG").remove();
    }, 1500);
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/utiles/message.js
// module id = 65
// module chunks = 0